import { Box } from '@mui/material';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';

export const MAIN_CONTENT_ID = 'main-content';

/**
 * Lets keyboard users jump past the side nav. Hidden until it takes focus, so it must be the
 * first focusable element on the page. The target needs `tabIndex={-1}` to accept focus.
 */
export const SkipLink = () => {
  const { t } = useTranslation();

  // Focus the target directly; following the href would push the hash into the router's URL.
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    document.getElementById(MAIN_CONTENT_ID)?.focus();
  };

  return (
    <Box
      component="a"
      href={`#${MAIN_CONTENT_ID}`}
      onClick={handleClick}
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 1,
        boxShadow: 3,
        color: 'text.primary',
        fontWeight: 600,
        left: 8,
        px: 2,
        py: 1,
        position: 'fixed',
        top: 8,
        transform: 'translateY(calc(-100% - 16px))',
        zIndex: 'tooltip',
        '&:focus': {
          transform: 'none',
        },
      }}
    >
      {t('common.actions.skip_to_content')}
    </Box>
  );
};
